export const createLoadingSelector = actions => state => {
    if (!state.loading.INITIAL) {
        return actions.some(action => state.loading[action]);
    }

    state.loading.INITIAL = false;

    return true;
};
